// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3jVl7","row":"ProcedureTreatmentSummary_row__TWRWE"};